const inRange = (value: number, start: number, end: number) => value >= start && value <= end

/**
 * @deprecated Move this function to a more specific domain module as needed.
 */
export const calculator = { inRange }
